export default "__VITE_ASSET__C7dQ9POE__"